import { Component, OnInit } from '@angular/core';
import {ToastService} from '../core/toast/toast.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit {

  constructor(private toastService: ToastService) { }

  ngOnInit() {
  }
  showMessage() {
    this.toastService.success('hello', 'World!!');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts